/** sessionStorage key: superadmin tenant for billing API calls (sent as X-Tenant-Id). */
export const BILLING_TENANT_STORAGE_KEY = 'arrangelly_billing_tenant_id';
